import { useMemo } from 'react';
import { ExperienceResource } from 'src/typings/api-models.generated';
import { BsIcon } from 'src/ui/shared/components/icon/bs-icon.models';
import { Icon } from 'src/ui/shared/components/icon/Icon';

interface Props {
    resource: ExperienceResource;
}

export const VerificationResourceDisplay = ({ resource }: Props): React.ReactElement => {
    const icon = useMemo((): BsIcon => {
        switch (resource.type) {
            case 'audio':
                return 'file-earmark-music';
            case 'download':
                return 'file-earmark-arrow-down';
            case 'image':
                return 'file-earmark-image';
            case 'video':
                return 'file-earmark-play';
            case 'link':
                return 'box-arrow-up-right';
            case 'object':
            case 'embed':
            case 'iFrame':
            default:
                return 'box-arrow-up-right';
        }
    }, [resource.type]);

    return (
        <span>
            <Icon icon={icon}>
                <a href={resource.url} rel="noreferrer" target="_blank">
                    {resource.name}
                </a>
            </Icon>
        </span>
    );
};
